import PageHeading from "component/ui/PageHeading";
import { Pencil, Trash } from "lucide-react";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CommonModal from "component/ui/CommonModal";
import { useDispatch, useSelector } from "react-redux";
import { deleteEvent, getPostingList } from "store/slice/booking";
import gameIcon from "../../assets/game-on.png";
import serviceIcon from "../../assets/service_icon.png";
import partner from "../../assets/partners.png";
import notepad from "../../assets/notepad.png";
import { getSportsIcon } from "helper/appConstant";
import {
  CARD_TYPE,
  CARDS_ENUMS,
  CARDS_NAVIGATION_ENUMS,
  TYPES,
} from "helper/constant";
import FullPageLoader from "component/ui/fullPageLoader";
import Button from "component/ui/Button";
import SearchInput from "component/ui/SearchInput";
import { FiSearch } from "react-icons/fi";
import matchIcon from "../../assets/request_match.png";
import venueIcon from "../../assets/venue.png";

const EventBox = React.memo(
  ({ event, configData, navigate, setIsModalOpen }) => {
    return (
      <div
        key={event?.id}
        className="bg-white border border-gray-200 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 overflow-hidden"
      >
        {/* Header Section */}
        <div className="bg-gradient-to-r from-gray-100 to-gray-200 p-2 flex justify-between items-start">
          <div className="flex gap-3 items-start flex-1">
            <div
              style={{
                background:
                  event?.cardType == CARDS_ENUMS?.EVENT ||
                  event?.cardType == CARDS_ENUMS?.GAME
                    ? "#dc546c"
                    : event?.cardType == CARDS_ENUMS?.SERVICE
                    ? "#4eb4df"
                    : event?.cardType == CARDS_ENUMS?.JOIN
                    ? "#5fb55f"
                    : "#eda63b",
              }}
              className="w-8 h-8 rounded-lg  p-1.5 shadow-sm flex-shrink-0"
            >
              <img
                src={
                  event?.cardType == CARDS_ENUMS?.EVENT ||
                  event?.cardType == CARDS_ENUMS?.GAME
                    ? gameIcon
                    : event?.cardType == CARDS_ENUMS?.SERVICE
                    ? serviceIcon
                    : event?.cardType == CARDS_ENUMS?.JOIN
                    ? matchIcon
                    : venueIcon
                }
                className="w-full h-full object-contain "
              />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-base font-medium text-gray-800 line-clamp-1">
                {event?.cardType && CARD_TYPE[event?.cardType]}
              </p>
              <p
                className="text-xs border-b font-semibold border-highlight w-fit text-highlight cursor-pointer"
                onClick={() =>
                  navigate(
                    `/card-details/${CARDS_NAVIGATION_ENUMS[event?.cardType]}/${
                      event?.cardId
                    }`
                  )
                }
              >
                View Details
              </p>
            </div>
          </div>

          <div className="flex gap-2 ml-2">
            {!(event?.isRequirementFull || event?.paymentId) && (
              <button className="group">
                <Pencil
                  size={28}
                  onClick={() =>
                    navigate(
                      event?.cardType == CARDS_ENUMS?.EVENT
                        ? `/event/card/${event?.cardId}`
                        : event?.cardType == CARDS_ENUMS?.SERVICE
                        ? `/event/request-service/${event?.cardId}`
                        : event?.cardType == CARDS_ENUMS?.JOIN
                        ? `/club/match/${event?.cardId}`
                        : ""
                    )
                  }
                  className="p-1.5 rounded-lg text-hightlight bg-white shadow-md hover:shadow-lg transition-all hover:scale-110"
                />
              </button>
            )}
            <button className="group">
              {!(
                (event?.isRequirementFull == true &&
                  event?.isGameCompleted == false &&
                  event?.startDateTimeUtc != null &&
                  new Date().getTime() > Number(event?.startDateTimeUtc)) ||
                event?.canNotDelete
              ) && (
                <Trash
                  onClick={setIsModalOpen}
                  size={28}
                  className="p-1.5 rounded-lg text-red-600 bg-white shadow-md hover:shadow-lg transition-all hover:scale-110"
                />
              )}
            </button>
          </div>
        </div>

        {/* Content Section */}
        <div className="flex items-start justify-between w-full p-2">
          <div className="flex flex-col gap-1 flex-1">
            {event?.cardReferenceID && (
              <div className="flex items-center gap-3 py-1">
                <div className="w-6 h-6 ">🧾</div>

                <p className="font-normal text-gray-800 text-sm">
                  {event?.cardReferenceID}
                </p>
              </div>
            )}
            {/* Organizer */}
            {event?.cardType != CARDS_ENUMS?.VENUE && event?.details && (
              <div className="flex items-center gap-3 py-1">
                <img
                  src={notepad}
                  alt={event?.organizer}
                  className="w-6 h-6 "
                />

                <p className="font-normal text-gray-800 text-sm">
                  {event?.details ? event?.details : "-"}
                </p>
              </div>
            )}
            {event?.cardType != CARDS_ENUMS?.VENUE && (
              <div className="flex items-center gap-3 py-1">
                <div className="w-6 h-6 ">🏃</div>
                <p className="text-gray-600 text-sm font-normal">
                  {event?.noOfPlayers}
                </p>
              </div>
            )}

            {/* Date */}
            {event?.cardType != CARDS_ENUMS?.JOIN && (
              <div className="flex items-center gap-3 text-sm text-gray-600">
                <span className="text-lg">📅</span>
                <span className="font-normal">
                  {event?.startDate}{" "}
                  {event?.startTime != "00:00" && event?.startTime}
                </span>
              </div>
            )}

            {/* Location */}
            {event?.cardType != CARDS_ENUMS?.SERVICE &&
              event?.location?.address && (
                <div className="flex items-center gap-3 text-sm text-gray-600">
                  <span className="text-lg">📍</span>
                  <span className="font-normal line-clamp-1">
                    {event?.location?.address}
                  </span>
                </div>
              )}
          </div>

          {/* Category Badge */}
          <div className="flex items-center flex-col justify-center p-3 rounded-xl bg-gradient-to-br from-blue-100 to-blue-200 w-28 shadow-sm ml-3">
            <div className="w-10 h-10 flex justify-center rounded-lg bg-white p-2 shadow-sm mb-2">
              {getSportsIcon(configData?.gamesDetails, event?.sportName)}
            </div>
            <p className="text-xs font-semibold text-gray-700 text-center line-clamp-2 leading-tight">
              {event?.sportName}
            </p>
          </div>
        </div>
      </div>
    );
  }
);
const MyPosting = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { postingListData } = useSelector((state) => state.booking);
  const { configData } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const [deleteData, setDeleteData] = useState(null);
  const [searchQuery, setSearchQuery] = useState();
  useEffect(() => {
    setLoading(true);
    fetchPostingList();
  }, []);
  // fetch my posting list
  const fetchPostingList = (page, search) => {
    dispatch(
      getPostingList(
        page ?? 1,
        12,
        search ? search : searchQuery ?? "",
        setLoading
      )
    );
  };
  console.log("postingListData", postingListData);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleDeleteSuccess = () => {
    setLoading(false);
    setIsModalOpen(false);
  };
  const handleConfirm = async () => {
    setLoading(true);
    const request = {
      language: "en",
      id: deleteData?.cardId,
      roomId: null,
      type:
        deleteData?.cardType == "event"
          ? TYPES?.EVENT_DELETE_TYPE
          : TYPES?.SERVICE_DELETE_TYPE,
    };
    dispatch(deleteEvent(request, handleDeleteSuccess));
  };

  const handleAssign = () => {
    navigate("/assign-match");
  };

  const handleRequest = () => {
    navigate("/request-sent");
  };
  return (
    <>
      <div className="min-h-screen p-4 md:p-6">
        <div className="container mx-auto">
          <div className="flex items-center justify-between">
            <PageHeading title="My Posting" />
            <div className="flex items-center gap-2">
              <Button onClick={handleAssign}>Assign Matches</Button>
              <Button onClick={handleRequest}>Request Send</Button>
            </div>
          </div>
          {loading && <FullPageLoader />}
          <div className="rounded-2xl md:shadow-2xl md:bg-white border border-gray-100 overflow-hidden w-full md:p-5">
            <div className="w-1/2">
              <SearchInput
                value={searchQuery}
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                  fetchPostingList(null, e.target.value);
                }}
                placeholder="Search by card id/sport"
                icon={FiSearch}
                className="rounded-full"
              />
            </div>

            {postingListData?.data?.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-4">
                {postingListData?.data?.map((event) => (
                  <EventBox
                    event={event}
                    configData={configData}
                    navigate={navigate}
                    setIsModalOpen={() => {
                      setIsModalOpen(true);
                      setDeleteData(event);
                    }}
                  />
                ))}
              </div>
            ) : (
              <div className="flex justify-center items-center h-40">
                No Posting Found
              </div>
            )}
          </div>
        </div>
      </div>

      <CommonModal
        isOpen={isModalOpen}
        title="Delete Item"
        message="Are you sure you want to delete this card?"
        confirmButtonText="Yes, Delete"
        cancleButtonText="Cancel"
        onConfirm={handleConfirm}
        onCancel={() => setIsModalOpen(false)}
        isFullPageLoading={loading}
        icon={<Trash />}
      />
    </>
  );
};

export default MyPosting;
